import React, { useContext, useEffect } from 'react';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';
import PropTypes from 'prop-types';
import CTAButton from '../../buttons/CTAButton';
import RegFormStyles from '../../../css/components/forms/standard/oneClickForm.css';
import Terms from '../Terms';
import AlreadyRegisteredLink, { ALREADY_REGISTERED_LINK_POSITION } from '../../common/AlreadyRegisteredLink';
import { withInlineValidation } from '../../../helpers/validation/inline-validation';
import { withIppButtons } from '../../../helpers/ipp-buttons';
import { TermsCheckboxContext } from '../../../state-management/contexts/regform-checkboxes/terms-checkbox-context';
import { useTranslation } from 'react-i18next';

function OneClickForm({
	onTermsCheckedCallback,
	handlePlayClick,
	showLoadingIndicator,
}) {
	const { t } = useTranslation('translation');
	const [,termsDispatch] = useContext(TermsCheckboxContext);
	const onelpsParams = useContext(OneLPSsdkParamsContext);

	useEffect(() => {
		if(!onelpsParams.form.showTermsCheckbox){
			termsDispatch({ type: 'SET_TC_VALUE', payload: true });
		}
	}, []);

	const formSectionClassNames = `
		${RegFormStyles.formContainer}
		${RegFormStyles[onelpsParams.gameId]}`;

	const regForm = (
		<form
			className={RegFormStyles.form}
			onKeyDown={(e) => {
				if (e.key === 'Enter') {
					e.preventDefault();
					handlePlayClick();
				}
			}}
		>
			<main className={RegFormStyles.formMain}>
				<div className={RegFormStyles.oneClickButtonWrapper}>
					<CTAButton
						onButtonClick={handlePlayClick}
						buttonLabel={t(onelpsParams.form.buttonTranslationKeys[0])}
						buttonId='page_registration_one-click_button_register'
						extraClassName={'oneClickCtaButton'}
						isDisabled={showLoadingIndicator}
					/>
				</div>

				<div className={RegFormStyles.oneClickLegalWrapper}>
					<Terms
						onChangeCallback={onTermsCheckedCallback}
						showCheckbox={onelpsParams.form.showTermsCheckbox}
						termsLinkId='page_registration_one-click_text_terms-and-conditions'
						privacyLinkId='page_registration_one-click_text_privacy-policy'
						extraStyle='oneClickTerms'
					>
					</Terms>

					<hr/>

					<div>
						<AlreadyRegisteredLink
							linkText={t('loginForm.alreadyRegistered')}
							position={ALREADY_REGISTERED_LINK_POSITION.ONE_CLICK}/>
					</div>

				</div>

			</main>
		</form>
	);

	return (
		<>
			<section className={formSectionClassNames}>
				{ regForm }
			</section>
		</>
	);
}

OneClickForm.propTypes = {
	errDelay: PropTypes.number.isRequired,
	handlePlayClick: PropTypes.func.isRequired,
	onTermsCheckedCallback: PropTypes.func.isRequired,
	showLoadingIndicator: PropTypes.bool.isRequired,
};

const EnhancedOneClickForm =
	withIppButtons(
		withInlineValidation(
			OneClickForm
		)
	);
export default EnhancedOneClickForm;
